"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queueSceneLayoutSelector = queueSceneLayoutSelector;
var _constants = require("@studio/constants");
/**
 * @param {Array} sources
 * @param {Function} predicateFn
 */
function containSourceType(sources, predicateFn) {
  return sources.some(function (source) {
    return predicateFn(source);
  });
}

/**
 * @param {{}} stagedSources
 * @param {Array} broadcastSources
 */
function queueSceneLayoutSelector(stagedSources, broadcastSources) {
  var sources = broadcastSources.filter(function (source) {
    return stagedSources[source._id];
  });
  var containImageOrVideoOrPdf = containSourceType(sources, function (source) {
    return [_constants.IMAGE_FILE, _constants.PDF_FILE, _constants.VIDEO_FILE].includes(source.type);
  });
  var containCamera = containSourceType(sources, function (source) {
    return source.type === _constants.CAMERA_PRESENTER;
  });
  var containScreenShare = containSourceType(sources, function (source) {
    return source.type === _constants.SCREEN_PRESENTER;
  });
  if (containCamera && sources.length === 1) {
    return _constants.GRID;
  }
  if (sources.length === 1) {
    return _constants.SINGLE;
  }
  if (containCamera && containImageOrVideoOrPdf) {
    return _constants.FEATURED_MEDIA;
  }
  if (containCamera && containScreenShare) {
    return _constants.FEATURED_SCREEN;
  }
  if (containCamera && sources.length >= 1) {
    return _constants.GRID;
  }

  /**
   * We have a visual media source (screen, video or image) but it's not the
   * only source. Since we've ruled out the presence of a presenter, the
   * second source is an audio source
   */
  if (containScreenShare || containImageOrVideoOrPdf) {
    return _constants.SINGLE;
  }
}